import { Component } from 'react';

import './loading-container.css';

export class LoadingContainer extends Component {
   render() {
      if (this.props.loading)
         return (
            <svg className="loading-container">
                <use href="svg/loader.svg#src" />
            </svg>
         );

      return this.props.children;
   }
}